export const gtmId = "GTM-WSRZ5BNN";

export const baseUrl = process.env.REACT_APP_BASE_URL || null;

export const JAZZCASH_REDIRECT_URL = `https://jhoom.mobi/jcms/link-wallet`;

export const recaptchaSiteKey = "6LcbPUstAAAAAGEvt_ilr5CFnR8fPXlRf9P8sRhJ";
